<template>
  <div class="mobile teas-my-todo-div">
    <div class="search">
      <van-search
        v-model="keywords"
        shape="round"
        @input="search"
        placeholder="搜索"
      />
    </div>
    <div class="teas-my-todo-main" v-if="dataList.length > 0">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          finished-text="没有更多了"
          @load="getList"
        >
          <div class="teas-my-todo-item" v-for="(item , index) in dataList" :key="'teas-my-todo-item' + index" @click="rowClick(item)">
            <div class="teas-my-todo-item-top">
              <div class="item-name">{{item.moduleName || ""}}</div>
              <div class="item-content">{{item.content || ""}}</div>
            </div>
            <div class="teas-my-todo-item-bottom">
              <div :class="parseInt(item.status) == 1 ? 'item-status-read' : 'item-status-unread'">{{item.statusText || ""}}</div>
              <div class="item-publishname" v-if="item.sendUserName && item.sendUserName.length > 0">
                <span class="iconfont icon-tab-mine item-icon"></span>
                <span>{{item.sendUserName || ""}}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="teas-my-todo-main" v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileTeasMyTodo",
  ctrlCaption: "我的待办",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      dataList: [],
      keywords: "",
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pageNum: 0,
      pageSize: 20,
      messageType: "",
    };
  },
  props: {
    url: {
      type: String,
      default: "message/info/getMessageList",
    },
  },
  created() {},
  mounted() {
    this.messageType = this.queryString.messageType || "";
    if (this.isDesign) {
      this.dataList = [];
      this.$dispatch("design-width-change", "100%");
    } else {
      this.getList();
    }
  },
  computed: {},
  methods: {
    search: _.debounce(function () {
      this.onRefresh();
    }, 300),
    // 获取列表数据
    getList(isRefresh = false) {
      if (this.isDesign) {
        return;
      }
      const loading = dsf.layer.loading();
      this.pageNum++;
      this.$http
        .get(this.url, {
          pageNum: this.pageNum,
          pageSize: 20,
          searchValue: this.keywords,
          type: this.messageType || "",
          isMergeModule: "0",
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            let tempArr = res.data || [];
            if (tempArr.length == 0) {
              this.finished = true;
            } else {
              if (isRefresh) {
                this.dataList = tempArr;
              } else {
                this.dataList.push(...tempArr);
              }
              this.finished = false;
            }
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true;
        })
        .always(() => {
          this.loading = false;
          this.refreshing = false;
          dsf.layer.closeLoading(loading);
        });
    },
    // 刷新
    onRefresh() {
      this.pageNum = 0;
      this.getList(true);
    },
    rowClick: function (item) {
      if (this.$listeners["rowClick"]) {
        this.$dispatch("rowClick", item);
      }
      else{
        if (item['mobile_url']) {
          window.location.href = dsf.url.getWebPath(item['mobile_url'])
        } else {
          dsf.layer.message("请在pc端操作此数据", false);
        }
      }
      },
  },
});
</script>